export function highlightWords(text = '', word = '') {
    if (!text.length || !word.length) {
        return text;
    }
    const regExp = new RegExp(`(${word})`, 'gi');
    return text?.replaceAll(regExp, `<mark>$1</mark>`);
}
